module.exports = __webpack_public_path__ + "media/images/official/referral_step_mypage-20016b04ad6a12575cb63ee0baae0c65.webp";